import { Component, HostBinding, OnInit } from '@angular/core';
import { appConfig } from '@box-configs/app.config';

@Component({
  selector: 'landing-merchants',
  templateUrl: './landing-merchants.component.html',
  styleUrls: ['./landing-merchants.component.scss']
})
export class LandingMerchantsComponent implements OnInit {
  public zohoUrl: string;

  @HostBinding('class') hostClass = 'landing-merchants';

  ngOnInit(): void {
    this.zohoUrl = appConfig.ZOHO_URL;
  }
}
